module.exports = __webpack_public_path__ + "img/nota-codigo.c6330f3e.png";